<template>
  <main id="main">
    <transition name="fade">
      <Loader v-if="!$page" />
    </transition>
    <template v-if="$page">
      <JobHeader :content="$page.header" :job="currentJob" :business="currentBusiness" />

      <JobContent :content="$page.content" :job="currentJob" />

      <FormSection :content="$page.form" :job-id="currentJob.id" />
    </template>
  </main>
</template>

<script>
import FormSection from '@/components/sections/FormSection.vue'
import JobContent from '@/components/sections/JobContent.vue'
import JobHeader from '@/components/sections/JobHeader.vue'
import Loader from '@/components/small/Loader.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'Job',
  beetPage: 'job',
  props: {
    jobSlug: {
      type: String,
      required: true,
    },
  },
  components: { FormSection, JobContent, JobHeader, Loader },
  computed: {
    currentJob() {
      const id = this.$store.getters.jobsSlugMap[this.jobSlug]
      if (!id) this.$router.replace({ name: 'home', hash: '#jobs' })
      return this.$beet.jobs[id]
    },
    currentBusiness() {
      return this.$beet.businesses[this.currentJob.business]
    },
  },
  watch: {
    $page() {
      if (this.$page) {
        setMeta({
          ...this.$page.seo,
          title: this.currentJob.title,
          description: this.currentJob.description,
          image: this.currentJob.image.original,
        })
      }
    },
    '$route.name': {
      immediate: true,
      handler() {
        if (this.$page && this.currentJob) {
          setMeta({
            ...this.$page.seo,
            title: this.currentJob.title,
            description: this.currentJob.description,
            image: this.currentJob.image.original,
          })
        }
      },
    },
  },
}
</script>
